import { DatePicker, Input } from "antd";
import dayjs from "dayjs";
import moment from "moment";
import React from "react";
import { isSustrax, planValue } from "../../helper/plans";
import { timeFormat } from "../../helper/time";
import FakeLabel from "./select";
import SelectSearch from "../select/SearchSelect";
import { currentYearForPremiumAndBasicAtom } from "../header/configAtom";
import { useAtom } from "jotai";

function disabledDate(current) {
  // Disable dates after the current year and before 2016
  return current && current.year() > 2025;
}

const VisibleTimeFormat = "DD/MM/YYYY";

export default function DateInput({ value, setValue, title = "Select Date", ...more }) {
  if (value === "Invalid date") value = undefined;
  const [currentYearForPremiumAndBasic] = useAtom(currentYearForPremiumAndBasicAtom);
  const elem = (
    <DatePicker
      allowClear={more?.clear ?? false}
      format={VisibleTimeFormat}
      value={value ? dayjs(value, timeFormat) : null}
      onChange={(x, y) => {
        setValue(moment(y, VisibleTimeFormat).format(timeFormat));
      }}
    ></DatePicker>
  );
  let canSelectCustomDate = planValue("canSelectCustomDate");
  if (more.is_consultant_page) canSelectCustomDate = true;
  if (!canSelectCustomDate && !more.canSelectCustomDate) {
    if (isSustrax(["basic", "premium"])) {
      return <div onClick={() => {
        const dropdown = document.getElementById("data-input-year-dropdown");
        if (dropdown) {
          const selectElement = dropdown.querySelector('.ant-select-selector')
          if (selectElement) {
            selectElement.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
            selectElement.classList.add("highlight-red");
            setTimeout(() => {
              selectElement.classList.remove("highlight-red");
            }, 1500);
          }
        }
      }}>
        <FakeLabel {...more} description={"Please select the data input year from the dropdown in the top right."} title={"Year"} elem={

          <Input
            className="no-select disabled-input"
            value={currentYearForPremiumAndBasic}

          />
        } />
      </div>
    }
    return null; // myles request: 1/2/24
    return <FakeLabel {...more} description={" "} title={"Year"} elem={<Input className="no-select" disabled value={moment().format("YYYY")} />} />;
  }
  return <FakeLabel {...more} title={!canSelectCustomDate ? "Year" : title} elem={canSelectCustomDate ? elem : <Input disabled value={moment().format("YYYY")} />} />;
}
